/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleSearchConsoleBrandQueryData } from './GoogleSearchConsoleBrandQueryData';
import {
    GoogleSearchConsoleBrandQueryDataFromJSON,
    GoogleSearchConsoleBrandQueryDataFromJSONTyped,
    GoogleSearchConsoleBrandQueryDataToJSON,
    GoogleSearchConsoleBrandQueryDataToJSONTyped,
} from './GoogleSearchConsoleBrandQueryData';
import type { GoogleSearchConsoleBrandAggregateData } from './GoogleSearchConsoleBrandAggregateData';
import {
    GoogleSearchConsoleBrandAggregateDataFromJSON,
    GoogleSearchConsoleBrandAggregateDataFromJSONTyped,
    GoogleSearchConsoleBrandAggregateDataToJSON,
    GoogleSearchConsoleBrandAggregateDataToJSONTyped,
} from './GoogleSearchConsoleBrandAggregateData';
import type { GoogleSearchConsoleBrandRuleSetData } from './GoogleSearchConsoleBrandRuleSetData';
import {
    GoogleSearchConsoleBrandRuleSetDataFromJSON,
    GoogleSearchConsoleBrandRuleSetDataFromJSONTyped,
    GoogleSearchConsoleBrandRuleSetDataToJSON,
    GoogleSearchConsoleBrandRuleSetDataToJSONTyped,
} from './GoogleSearchConsoleBrandRuleSetData';

/**
 * 
 * @export
 * @interface GoogleSearchConsoleBrandReportData
 */
export interface GoogleSearchConsoleBrandReportData {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSearchConsoleBrandReportData
     */
    available?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSearchConsoleBrandReportData
     */
    configured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSearchConsoleBrandReportData
     */
    partial?: boolean;
    /**
     * 
     * @type {Array<GoogleSearchConsoleBrandAggregateData>}
     * @memberof GoogleSearchConsoleBrandReportData
     */
    aggregates?: Array<GoogleSearchConsoleBrandAggregateData>;
    /**
     * 
     * @type {Array<GoogleSearchConsoleBrandQueryData>}
     * @memberof GoogleSearchConsoleBrandReportData
     */
    queries?: Array<GoogleSearchConsoleBrandQueryData>;
    /**
     * 
     * @type {Array<GoogleSearchConsoleBrandRuleSetData>}
     * @memberof GoogleSearchConsoleBrandReportData
     */
    revisions?: Array<GoogleSearchConsoleBrandRuleSetData>;
}

/**
 * Check if a given object implements the GoogleSearchConsoleBrandReportData interface.
 */
export function instanceOfGoogleSearchConsoleBrandReportData(value: object): value is GoogleSearchConsoleBrandReportData {
    return true;
}

export function GoogleSearchConsoleBrandReportDataFromJSON(json: any): GoogleSearchConsoleBrandReportData {
    return GoogleSearchConsoleBrandReportDataFromJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandReportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleBrandReportData {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'] == null ? undefined : json['available'],
        'configured': json['configured'] == null ? undefined : json['configured'],
        'partial': json['partial'] == null ? undefined : json['partial'],
        'aggregates': json['aggregates'] == null ? undefined : ((json['aggregates'] as Array<any>).map(GoogleSearchConsoleBrandAggregateDataFromJSON)),
        'queries': json['queries'] == null ? undefined : ((json['queries'] as Array<any>).map(GoogleSearchConsoleBrandQueryDataFromJSON)),
        'revisions': json['revisions'] == null ? undefined : ((json['revisions'] as Array<any>).map(GoogleSearchConsoleBrandRuleSetDataFromJSON)),
    };
}

export function GoogleSearchConsoleBrandReportDataToJSON(json: any): GoogleSearchConsoleBrandReportData {
    return GoogleSearchConsoleBrandReportDataToJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandReportDataToJSONTyped(value?: GoogleSearchConsoleBrandReportData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available': value['available'],
        'configured': value['configured'],
        'partial': value['partial'],
        'aggregates': value['aggregates'] == null ? undefined : ((value['aggregates'] as Array<any>).map(GoogleSearchConsoleBrandAggregateDataToJSON)),
        'queries': value['queries'] == null ? undefined : ((value['queries'] as Array<any>).map(GoogleSearchConsoleBrandQueryDataToJSON)),
        'revisions': value['revisions'] == null ? undefined : ((value['revisions'] as Array<any>).map(GoogleSearchConsoleBrandRuleSetDataToJSON)),
    };
}

